import { Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import {useCallback, useState} from 'react';
import clsx from 'clsx';
import ProvisonalDiagnosis from '../../../../phan-he-kham-benh/components/ProvisonalDiagnosis';

type Props = {
    rowClassName?: string;
    containerClassName?: string;
    endRowClassName?: string;
    formName: string;
    isView?: boolean;
    icd10Field?: string;
    hasDiagnosisNonCoded?: boolean;
    onChange?: (value: any) => void;
    fieldValue?: any;
    diagnosisList?: any[];
};

const ChanDoan = ({
    rowClassName,
    containerClassName,
    endRowClassName,
    formName,
    isView,
    icd10Field = 'ggtDiagnosis',
    hasDiagnosisNonCoded = true,
    onChange,
    fieldValue,
    diagnosisList
}: Props) => {
    const { values, errors, touched, setFieldValue } = useFormikContext<any>();

    const [listComorbidity, setListComorbidity] = useState();

    const handleChange = useCallback((data: any) => {
        if (onChange) {
            onChange(data);
            return;
        }

        delete data?.comorbidity;
        setFieldValue(`additionalForms.${formName}`, {
            ...values?.additionalForms?.[formName],
            ...data
        });
    }, [formName, onChange, setFieldValue, values?.additionalForms]);

  const handleSetListComorbidity = useCallback((data: any) => {
    setListComorbidity(data);
  }, []);

  const handleChangeEncounterDiagnosis = useCallback(
    (name: string, value: any) => handleChange({ [name]: value }),
    [handleChange]
  );

  return (
        <div
            className={`spaces p-0 ${containerClassName || ''}`}>
            <Row
                className={clsx(
                    'position-relative w-100 spaces px-0 mx-0'
                )}
            >
                <ProvisonalDiagnosis
                    encounterDiagnosisValues={fieldValue ?? values?.additionalForms?.[formName]}
                    encounterDiagnosisErrors={errors}
                    encounterDiagnosisTouched={touched}
                    listComorbidity={listComorbidity}
                    setListComorbidity={handleSetListComorbidity}
                    onChange={handleChange}
                    handleChangeEncounterDiagnosis={handleChangeEncounterDiagnosis}
                    rowClassName={clsx(rowClassName)}
                    endRowClassName={endRowClassName}
                    icd10Field={icd10Field}
                    diagnosisNonCodedField='ggtDiagnosisNonCoded'
                    disabled={isView}
                    hasDiagnosisNonCoded={hasDiagnosisNonCoded}
                    diagnosisList={diagnosisList}
                />
            </Row>
        </div>
    );
};

export default ChanDoan;
